import { render, staticRenderFns } from "./GiftCardList.vue?vue&type=template&id=3466b4bc&"
import script from "./GiftCardList.vue?vue&type=script&lang=js&"
export * from "./GiftCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports